module.exports = __webpack_public_path__ + "img/hyl_title2.8d8b9155.png";